import { Reveal, SectionHead } from './Reveal';
import { Smartphone, SearchCheck, FileCheck2, ArrowRight } from 'lucide-react';
import { WA_NUMBER_DISPLAY, waLink } from '../lib/lead';

const STEPS = [
  {
    num: '01',
    icon: Smartphone,
    title: 'Submit Details',
    desc: 'Enter your vehicle number or upload the challan photo via web or WhatsApp: 8383854950. Takes under 60 seconds.',
  },
  {
    num: '02',
    icon: SearchCheck,
    title: 'Legal Assessment',
    desc: 'Our legal experts review disputes, virtual court notices, and reduce penalties legally — before you pay anything.',
  },
  {
    num: '03',
    icon: FileCheck2,
    title: 'Fast Disposal & Clearance',
    desc: 'Receive your authentic court receipt and see the updated disposal status reflected on Parivahan.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-[#F8FAFC]" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="How It Works"
          title="3 Simple Steps to a Clean Record"
          sub="No queues, no paperwork, no day off work. Just a WhatsApp message to start."
        />

        <div className="relative mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          <div className="hidden md:block absolute top-[52px] left-[16%] right-[16%] border-t-2 border-dashed border-brand-blue/20" aria-hidden="true" />
          {STEPS.map(({ num, icon: Icon, title, desc }, i) => (
            <Reveal key={num} delay={i * 0.12}>
              <div
                className="relative h-full rounded-2xl bg-white border border-slate-200 p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-brand-blue/10"
                data-testid={`how-it-works-step-${i + 1}`}
              >
                <span className="absolute top-6 right-7 font-display text-6xl font-bold text-brand-blue/8 select-none" aria-hidden="true">
                  {num}
                </span>
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-blue text-white shadow-lg shadow-brand-blue/25">
                  <Icon size={24} strokeWidth={2.2} />
                </span>
                <h3 className="mt-6 font-display text-2xl font-bold text-brand-ink">{title}</h3>
                <p className="mt-3 text-sm sm:text-[15px] leading-relaxed text-slate-500">{desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-brand-orange">
                  Step {num}
                  {i < 2 && <ArrowRight size={13} strokeWidth={3} />}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-center text-sm font-semibold text-slate-500">
            Prefer WhatsApp? Send your challan photo directly to{' '}
            <a
              href={waLink('Hi Settalkar, I am sharing a photo of my traffic challan for settlement.')}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-orange font-bold underline underline-offset-4 hover:text-brand-blue transition-colors"
              data-testid="how-it-works-whatsapp-link"
            >
              {WA_NUMBER_DISPLAY}
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
